import { ExperiencePurchaseItem } from "types";
import { RowData } from "./types";

export const reservationCellValueGetter = ({ data }: { data: RowData }) => {
    if ("balance" in data || !data.isOrganizer) {
        return null;
    }

    const { shortCode } = data.item as ExperiencePurchaseItem;

    return shortCode ? shortCode : null;
};

export const ReservationCellFormatter = ({ value }: { value: string | null }) => (value ? value.toUpperCase() : "");
